<template>
  <div >
    <div v-for="(
                  item,
                  index
                ) of content" :key="index">
        <p class="my-2 text-xs columns font-weight-bold"> <span>{{ item.batch }}</span></p>
    </div>
  </div>
</template>

<script>

export default {
  name: "ShipmentPackageBatchContent",
  components: {
  },
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
};

</script>

<style scoped>

  .columns {
    max-width: 150px;
  }

</style>